<template>
  <div class="places-page container" @keyup.esc="showModalDetails = false">
    <h1 class="title">
      Lugares
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
        style="background-color: #f5f5f5"
        v-if="isLoading"
      >
        ...
      </button>
    </h1>
    <div class="page-content">
      <data-table
        :data="places"
        show-index
        striped
      >

        <table-toolbar>
          <template slot="left">
            <div class="level-item">
              <p class="control">
                <router-link v-if="me.role !== 'moderator'" :to="`/${$route.params.lang}/places/add`" class="button is-primary">Adicionar</router-link>
              </p>
            </div>
          </template>
          <template slot="right">
            <!-- <div class="level-item">
              <p class="control has-addons">
                <input class="input" type="text" placeholder="Encontre um lugar">
                <button class="button">Pesquisar</button>
              </p>
            </div> -->
          </template>
        </table-toolbar>

        <column label="Nome" field="name" sorter="custom" />
        <!-- <column label="Tem Moderadores?" v-if="me.role !== 'moderator'">
          <template slot-scope="row">
            <span v-if="row.moderators.length > 0">Sim</span>
            <span v-else>Não</span>
          </template>
        </column> -->
        <column label="Idioma" field="language" />
        <column label="Ativo">
          <template slot-scope="row">
            <span v-if="row.active">Sim</span>
            <span v-else>Não</span>
          </template>
        </column>
        <column label="Ações" :width="100">
          <template slot-scope="row">
            <div class="control has-addons is-pulled-right">
              <button
                class="button is-primary is-small"
                @click="showDetails(row)"
              >
                Detalhar
              </button>
              <!-- <dropdown>
                <button class="button is-primary is-small">
                  <span class="icon is-small"><i class="fa fa-caret-down"></i></span>
                </button>
                <div slot="content">
                  <menus>
                    <menu-item
                      :click="() => EditPlace(row)"
                    >
                      Editar
                    </menu-item>
                  </menus>
                </div>
              </dropdown> -->
            </div>
          </template>
        </column>
      </data-table>
    </div>
  </div>
</template>

<script>
import { GetPlaces } from '../../api/place'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import PlaceViewer from '../PlaceViewer'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PlacesPage',
  mixins: [AsideMenuCtrlMixin],
  components: { PlaceViewer },
  data () {
    return {
      pageCtrl: {
        limit: 50,
        skip: 0,
        page: 0,
        language: this.$route.params.lang || this.DefaultLanguage
      },
      places: [],
      isLoading: false
    }
  },

  computed: {
    ...mapGetters([
      'DefaultLanguage',
      'me'
    ])
  },

  methods: {
    ...mapActions([
      'SetCurrentPlace',
      'SetCurrentPlaceQuizes'
    ]),
    getPlaces ({limit, skip, page, language}) {
      this.isLoading = true
      GetPlaces(limit, (limit * page), language)
        .then(
          success => {
            this.places = success.data.items
            this.isLoading = false
          },
          error => {
            console.log(error.response)
            this.isLoading = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter os Lugares.',
              duration: 10000
            })
          }
        )
    },
    showDetails (place) {
      this.SetCurrentPlace(place)
      this.SetCurrentPlaceQuizes({})
      this.SetCurrentPlaceQuizes([])
      this.$router.push(`/${this.$route.params.lang}/places/${place.id}`)
    },
    EditPlace (place) {
      this.SetCurrentPlace(place)
      this.$router.push(`/${this.$route.params.lang}/places/${place.id}/edit`)
    }
  },

  created () {
    this.getPlaces({...this.pageCtrl})
  }
}
</script>

<style lang="scss">
.details-modal {
  .modal-card {
    .modal-card-body {
      height: 500px;
      .field+.field {
        margin-top: 20px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/PlacesPage.vue